import React, { Component } from "react";

import { Table, Header, Icon, List } from "semantic-ui-react";

import { connect } from "react-redux";

import * as _ from "lodash";

import CapabilitiesControlDropdown from "./CapabilitiesControlDropdown";

const ListItem = props => {
  return (
    <List.Item>
      <List.Icon name={props.iconName} color="blue" />
      <List.Content>{props.children}</List.Content>
    </List.Item>
  );
};

const ReimbursementCapability = props => {
  let text = "";
  const canApprove = props.capabilities.includes("APPROVE_REIMBURSEMENTS");
  const canPay = props.capabilities.includes("PAY_REIMBURSEMENTS");
  if (canApprove && canPay) {
    text = "View, approve, and pay out reimbursements.";
  } else if (canApprove) {
    text = "View and approve reimbursements.";
  } else if (canPay) {
    text = "View and pay out reimbursements.";
  } else {
    text = "View your organization's reimbursements.";
  }
  return <ListItem iconName="clipboard check">{text}</ListItem>;
};

const CapabilitiesList = props => {
  if (props.owner) {
    return (
      <List>
        <ListItem iconName="check">Full access to Spout.</ListItem>
      </List>
    );
  } else if (props.capabilities.length === 0) {
    return (
      <List>
        <ListItem iconName="times">No access.</ListItem>
      </List>
    );
  }
  return (
    <List>
      {props.capabilities.includes("VIEW_REIMBURSEMENTS") && (
        <ReimbursementCapability capabilities={props.capabilities} />
      )}
      {props.capabilities.includes("MODIFY_SUBMITTERS") && (
        <ListItem iconName="clipboard check">
          Change who can submit reimbursements.
        </ListItem>
      )}
      {props.capabilities.includes("MODIFY_ORGANIZATION") && (
        <ListItem iconName="cogs">Modify basic organization settings.</ListItem>
      )}
      {props.capabilities.includes("VIEW_TRANSACTIONS") && (
        <ListItem iconName="university">View bank transaction data.</ListItem>
      )}
    </List>
  );
};

class UserRow extends Component {
  render() {
    const user = this.props.user;

    const icon =
      (user.is_primary_owner && "user secret") ||
      (user.is_owner && "user") ||
      "user outline";
    const designation =
      (user.is_primary_owner && "Primary Owner") ||
      (user.is_owner && "Owner") ||
      "Standard User";

    return (
      <Table.Row>
        <Table.Cell>
          <Header>
            <Icon name={icon} />
            <Header.Content>
              {user.first_name} {user.last_name}
              <Header.Subheader>{user.email}</Header.Subheader>
            </Header.Content>
          </Header>
        </Table.Cell>
        <Table.Cell>{designation}</Table.Cell>
        <Table.Cell>
          <CapabilitiesList
            capabilities={user.capabilities}
            owner={user.is_owner || user.is_primary_owner}
          />
        </Table.Cell>
        <Table.Cell>
          <CapabilitiesControlDropdown user={user} />
        </Table.Cell>
      </Table.Row>
    );
  }
}

const UsersTable = props => {
  return (
    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Name</Table.HeaderCell>
          <Table.HeaderCell>Account Type</Table.HeaderCell>
          <Table.HeaderCell>Capabilities</Table.HeaderCell>
          <Table.HeaderCell />
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {props.users.map((user, i) => <UserRow key={i} user={user} />)}
      </Table.Body>
      {
        // <Table.Footer>
        //   <Table.Row>
        //     <Table.HeaderCell textAlign="right" colSpan="4">
        //       <Button icon labelPosition="left" primary>
        //         <Icon name="plus" />Add user
        //       </Button>
        //     </Table.HeaderCell>
        //   </Table.Row>
        // </Table.Footer>
      }
    </Table>
  );
};

const mapStateToProps = state => ({
  users: _.sortBy(state.organization.users, user => user.first_name)
});

export default connect(mapStateToProps)(UsersTable);



// WEBPACK FOOTER //
// ./frontend/src/components/UsersTable.js